import { toastConfig } from 'lib/reactToastify/config';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { ErrorBoundary } from 'shared_DEPRECATED/components/Error/ErrorBoundary';

import { Chat } from 'features/chat/components/Chat';
import { DEFAULT_CHAT_FORM_VALUES } from 'features/chat/config';
import { ChatFormValues } from 'features/chat/config/types/ChatForm';
import { ChatProvider } from 'features/chat/context/chat';
import { ChatInterlocutorProvider } from 'features/chat/context/chatInterlocutor';
import { ChatMessageSchedulingProvider } from 'features/chat/context/chatMessageScheduling';
import { ChatMessagesProvider } from 'features/chat/context/chatMessages';

import { useChatToggle } from '../hooks';

const getToastRenderer = () => {
  let toastId: string | number = 0;

  return () => {
    if (!toastId) {
      toastId = toast.error(
        "There's an error with chat. Please try again later.",
        {
          icon: false,
          ...toastConfig,
        }
      );
    }

    return null;
  };
};

const renderToast = getToastRenderer();

type ChatPopupProps = {
  isOpen?: boolean;
  onToggle?: () => void;
  participantEmail?: string;
};

export function ChatPopup({
  isOpen,
  onToggle,
  participantEmail,
}: ChatPopupProps = {}) {
  const methods = useForm<ChatFormValues>({
    defaultValues: DEFAULT_CHAT_FORM_VALUES,
  });
  const [open, toggleOpen] = useChatToggle(isOpen, onToggle);

  return (
    <ErrorBoundary fallbackRender={renderToast}>
      <FormProvider {...methods}>
        <ChatInterlocutorProvider participantEmail={participantEmail}>
          <ChatProvider>
            <ChatMessageSchedulingProvider>
              <ChatMessagesProvider>
                <Chat open={open} toggleOpen={toggleOpen} />
              </ChatMessagesProvider>
            </ChatMessageSchedulingProvider>
          </ChatProvider>
        </ChatInterlocutorProvider>
      </FormProvider>
    </ErrorBoundary>
  );
}
